














import { Component, Prop } from "vue-property-decorator";
import { AgGridVue } from "ag-grid-vue";
import GridIconRowComponent from "../_shared/grid-components/grid-cells/grid-icon-row-component.vue";
import { Stock } from "@/interfaces/stock";
import GridColorChipComponent from "../_shared/grid-components/grid-cells/grid-color-chip-component.vue";
import {Grid} from "@/utils/grid/grid-helper";
import {PreferencesList} from "@/interfaces/preference";

@Component({
  name: "order-selected-packing-grid",
  components: { AgGridVue, GridIconRowComponent, GridColorChipComponent },
})
export default class OrderSelectedPackingGrid extends Grid {
  @Prop() rowData: Array<Stock>;

  @Prop({ default: false }) readonly: boolean;

  // eslint-disable-next-line @typescript-eslint/ban-types
  @Prop({ default: null }) deleteStockCallback: Function;

  async beforeMount() {
    super.beforeMount();
  }

  defaultPreference = {
    slug: PreferencesList.orderPacking,
    columns: ["sscc", "weight", "quantity", "support", "detailsProductCodes", "detailsProductNames", "detailsProductPCBs", "detailsBatchs", "detailsQties", "detailsQtyCols"],
  };

  columns = [
    {
      headerName: this.$t("packing-list.table.sscc"),
      field: "sscc",
      sortable: false,
      filterFramework: null,
      resizable: true,
      cellClass: "cell-align-left",
      width: 100
    }, {
      headerName: this.$t("packing-list.table.weight"),
      field: "weight",
      sortable: false,
      filterFramework: null,
      resizable: true,
      cellClass: "cell-align-right",
      width: 30
    }, {
      headerName: this.$t("packing-list.table.quantity"),
      field: "quantity",
      sortable: false,
      filterFramework: null,
      resizable: true,
      cellClass: "cell-align-right",
      width: 40
    }, {
      headerName: this.$t("packing-list.table.support"),
      field: "support",
      sortable: false,
      filterFramework: null,
      resizable: true,
      cellClass: "cell-align-right",
      width: 30
    },
    // Details
    {
      headerName: this.$t("packing-list.table.detail.productCode"),
      field: "detailsProductCodes",
      sortable: false,
      filterFramework: null,
      resizable: true,
      cellClass: "cell-align-left",
      width: 50,
      cellRenderer: (params) => params.data?.details.map(d => `• ${d?.product?.code ?? ''}`).join('<br>')
    }, {
      headerName: this.$t("packing-list.table.detail.productName"),
      field: "detailsProductNames",
      sortable: false,
      filterFramework: null,
      resizable: true,
      cellClass: "cell-align-left",
      width: 120,
      cellRenderer: (params) => params.data?.details.map(d => `• ${d?.product?.label ?? ''}`).join('<br>')
    }, {
      headerName: this.$t("packing-list.table.detail.productPcb"),
      field: "detailsProductPCBs",
      sortable: false,
      filterFramework: null,
      resizable: true,
      cellClass: "cell-align-left",
      width: 50,
      cellRenderer: (params) => params.data?.details.map(d => `• ${d?.product?.pcb ?? ''}`).join('<br>')
    }, {
      headerName: this.$t("packing-list.table.detail.batch"),
      field: "detailsBatchs",
      sortable: false,
      filterFramework: null,
      resizable: true,
      cellClass: "cell-align-left",
      width: 50,
      cellRenderer: (params) => params.data?.details.map(d => `• ${d?.batch ?? ''}`).join('<br>')
    }, {
      headerName: this.$t("packing-list.table.detail.quantity"),
      field: "detailsQties",
      sortable: false,
      filterFramework: null,
      resizable: true,
      cellClass: "cell-align-left",
      width: 50,
      cellRenderer: (params) => params.data?.details.map(d => `• ${d?.quantity ?? ''}`).join('<br>')
    }, {
      headerName: this.$t("packing-list.table.detail.quantityInCols"),
      field: "detailsQtyCols",
      sortable: false,
      filterFramework: null,
      resizable: true,
      cellClass: "cell-align-left",
      width: 50,
      cellRenderer: (params) => params.data?.details.map(d => `• ${d?.quantityInCols ?? ''}`).join('<br>')
    },
  ];
}
